import React from 'react';
import PropTypes from 'prop-types';
import RichText from '../Prismic/RichText';
import { hexToRgba, isContentBlank, buildImage } from './helpers';
import cx from 'classnames';
import './StepBannerImage.scss';

const Content = props => {
  if (isContentBlank(props.content) || !props.position.includes(props.textVerticalPosition)) {
    return null;
  }
  return (
    <div
      className={cx('content', { 'has-background': props.contentBackgroundColor })}
      style={{ backgroundColor: hexToRgba(props.contentBackgroundColor, props.contentBackgroundOpacity) }}>
      <RichText fields={props.content} color={props.contentColor}/>
    </div>
  );
};

const SeparateNumber = props => {
  if (!props.string) {
    return null;
  }
  return (
    <div className="separate-number" style={{ backgroundColor: props.backgroundColor }}>
      <span className="number">{props.string}</span>
    </div>
  );
};

const StepBannerImage = props => (
  <section className="split-banner-image">
    <div className="container-guttered">
      <RichText fields={props.title} className="split-banner-image-title"/>
      <div className="images-wrapper">
        {props.items.map((item, i) => (
          <div className={cx('image-part', { [props.textVerticalPosition]: props.textVerticalPosition })} key={i}>
            <Content {...props} content={item.content} position={['above-image']} />
            <div className="image">
              <SeparateNumber string={item.separateNumber} backgroundColor={props.numberBackgroundColor} />
              <Content {...props} content={item.content} position={['inside-top', 'inside-center', 'inside-bottom']} />
              <img src={buildImage(props, item)} alt={item.image.alt || ''} />
            </div>
            <Content {...props} content={item.content} position={['below-image']} />
          </div>
        ))}
      </div>
    </div>
  </section>
);

Content.propTypes = {
  contentColor: PropTypes.string,
  contentBackgroundColor: PropTypes.string,
  contentBackgroundOpacity: PropTypes.number,
  content: PropTypes.array,
  textVerticalPosition: PropTypes.string.isRequired,
  position: PropTypes.arrayOf(PropTypes.string).isRequired,
};

SeparateNumber.propTypes = {
  string: PropTypes.string,
  backgroundColor: PropTypes.string,
};

StepBannerImage.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.array,
    image: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
    separateNumber: PropTypes.string,
  })),
  title: PropTypes.array,
  textVerticalPosition: PropTypes.string.isRequired,
  numberBackgroundColor: PropTypes.string,
};

StepBannerImage.defaultProps = {
  numberBackgroundColor: '#2CB492',
};

export default StepBannerImage;



// WEBPACK FOOTER //
// ./src/client/js/view/components/StepBannerImage/StepBannerImage.js